import React, { useState, useEffect } from "react";
import axios from "axios";
import TextField from "@mui/material/TextField";
import "./LoginPage.css";
import { green } from "@mui/material/colors";

const host = process.env.REACT_APP_HOST;

const LoginPage = ({ setLoginAUTH }) => {
  const primaryGreen = green[600];
  const [Username, setUsername] = useState("");
  const [Password, setPassword] = useState("");
  const [loginColor, SetLoginColor] = useState("success");
  const [loginType, setLoginType] = useState("member");

  useEffect(() => {
    console.log("Username after update:", Username);
  }, [Username]);

  const handleUsernameChange = (event) => setUsername(event.target.value);
  const handlePasswordChange = (event) => setPassword(event.target.value);

  const keyDownHandler = (event) => {
    if (event.key === "Enter") {
      if (loginType === "guest" || (Username !== "" && Password !== "")) {
        handleLoginClick();
      }
    }
  };

  const handleLoginClick = async () => {
    const endpoint = loginType === "guest" ? `${host}/guest-login` : `${host}/login`;
    const payload = loginType === "member" ? { username: Username, password: Password } : {};

    try {
      const response = await axios.post(endpoint, payload, { withCredentials: true });
      if (response.data.status === "success" || response.data === "success") {
        const role = loginType === "member" ? "member" : "guest";
        localStorage.setItem("userRole", role);
        setLoginAUTH(true);
        window.location.reload(false);
      }
    } catch (error) {
      SetLoginColor("warning");
      console.error(`${loginType} login failed:`, error);
    }
  };

  return (
    <div className="login-container" id="login-container">
      <div className="login-window">
        {/* Left Side: Welcome Text and Images */}
        <div className="text-panel">
          <div className="welcome-text-container">
            <p className="welcome-title">
              Welcome to the Triquetra Knowledge Base Platform
            </p>
            <p>Please Login</p>
          </div>
          <div className="images-wrapper">
             <div className="picture-container">
                <img
                  src={require("../loginPictures/Triquetra-logo-300x285.png")}
                  alt="login-logo"
                />
              </div>
              <div className="picture-container2">
                <img
                  src={require("../loginPictures/2023-01-11-160743_003-copy-2.png")}
                  alt="login-arxaia"
                />
              </div>
          </div>
        </div>

        {/* Right Side: Login Controls */}
        <div className="login-panel">
          <div className="panel-content">
            <div className="login-toggle-group">
              <button 
                onClick={() => setLoginType("member")}
                className={`toggle-btn ${loginType === "member" ? "active" : ""}`}
                style={{ color: loginType === "member" ? primaryGreen : "gray" }}
              >
                Consortium Member
              </button>
              <button 
                onClick={() => setLoginType("guest")}
                className={`toggle-btn ${loginType === "guest" ? "active" : ""}`}
                style={{ color: loginType === "guest" ? primaryGreen : "gray" }}
              >
                Guest
              </button>
            </div>

            {loginType === "member" ? (
              <div className="input-fields">
                <TextField
                  label="Username"
                  variant="standard"
                  fullWidth
                  value={Username}
                  onChange={handleUsernameChange}
                  onKeyDown={keyDownHandler}
                  color={loginColor}
                  focused
                />
                <TextField
                  label="Password"
                  type="password"
                  variant="standard"
                  fullWidth
                  value={Password}
                  onChange={handlePasswordChange}
                  onKeyDown={keyDownHandler}
                  color={loginColor}
                  focused
                  style={{ marginTop: '20px' }}
                />
              </div>
            ) : (
              <div className="guest-notice">
                You are entering as a guest. Access to administrative tools and sensitive archaeological data will be restricted.
              </div>
            )}

            <div className="login-button" onClick={handleLoginClick}>
              {loginType === "member" ? "Log In" : "Enter as Guest"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;